import { usePermissions } from 'react-admin';
import { PermissionGroupRoles } from 'typings/enums';

// Roles allowed to view/edit shift swap, release, and drop settings
const ALLOWED_ROLES = new Set<string>([
  PermissionGroupRoles.support_agent,
  PermissionGroupRoles.support_admin,
  PermissionGroupRoles.admin,
  PermissionGroupRoles.sales_associate,
  PermissionGroupRoles.sales_admin,
  PermissionGroupRoles.sales_recruiter,
  'administrator',
]);

const useHasShiftRequestAccess = () => {
  const { permissions } = usePermissions();
  const groups = permissions?.permission_groups || [];

  const hasAccess = groups.some((g: { role?: string }) => g?.role && ALLOWED_ROLES.has(g.role));
  return hasAccess;
};

export default useHasShiftRequestAccess;
